import { Badge } from "@/components/ui/badge";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface ServiceInfo {
  name: string;
  subsector_name: string | null;
  category_id: string;
  descriere_juridica: string | null;
  descriere_practica: string | null;
  note_DNSC: string;
}

interface ServiceInfoModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  service: ServiceInfo | null;
}

export function ServiceInfoModal({
  open,
  onOpenChange,
  service,
}: ServiceInfoModalProps) {
  if (!service) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{service.name}</DialogTitle>
          <DialogDescription>{service.subsector_name}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Badge
              variant={
                service.category_id === "1" ? "destructive" : "secondary"
              }
              className="mb-2"
            >
              {service.category_id === "1" ? "Anexa 1" : "Anexa 2"}
            </Badge>
          </div>

          {service.descriere_juridica && (
            <div>
              <h4 className="font-semibold text-sm mb-2">Descriere juridică</h4>
              <p className="text-sm text-muted-foreground whitespace-pre-line">
                {service.descriere_juridica?.replace(/<br\s*\/?>/gi, "\n")}
              </p>
            </div>
          )}

          {service.descriere_practica && (
            <div>
              <h4 className="font-semibold text-sm mb-2">Descriere practică</h4>
              <p className="text-sm text-muted-foreground whitespace-pre-line">
                {service.descriere_practica?.replace(/<br\s*\/?>/gi, "\n")}
              </p>
            </div>
          )}

          {service.note_DNSC && (
            <div>
              <h4 className="font-semibold text-sm mb-2">Note DNSC</h4>
              <p className="text-sm text-muted-foreground whitespace-pre-line">
                {service.note_DNSC?.replace(/<br\s*\/?>/gi, "\n")}
              </p>
            </div>
          )}

          {!service.descriere_juridica &&
            !service.descriere_practica &&
            !service.note_DNSC && (
              <p className="text-sm text-muted-foreground italic">
                Nu există informații detaliate disponibile pentru acest
                serviciu.
              </p>
            )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
